import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  TextField,
  Divider,
  Button,
  createTheme,
  ThemeProvider,
  CssBaseline,
  Card,
  CardContent
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import toast, { Toaster } from 'react-hot-toast';

// नवीन स्वतंत्र घटक इम्पोर्ट केला
import PrintCertificate from './PrintCertificate';

export const API_BASE = 'http://localhost:3000/api';
export const KRUTI_FONT = 'Kruti Dev 010';

export const doPrint = () => {
  const printContent = document.getElementById('exact-certificate-print-view');
  if (printContent) {
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  } else {
    window.print();
  }
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1a237e' },
    secondary: { main: '#00e676' },
    background: { default: 'transparent', paper: '#ffffff' },
  },
  typography: {
    fontFamily: ['Noto Sans Devanagari', 'Mangal', 'Arial', 'sans-serif'].join(','),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body { background: transparent !important; }
        #exact-certificate-print-view { display: none; }
        @media print {
          .no-print-zone { display: none !important; }
          #exact-certificate-print-view {
            display: block !important;
            border: none !important;
            padding: 10px !important;
            background: #fff !important;
            color: #000 !important;
            width: 100% !important;
            height: 99% !important;
            overflow: hidden !important;
          }
          @page { size: A4 portrait; margin: 6mm 10mm 6mm 10mm; }
        }
      `,
    },
    MuiTextField: {
  defaultProps: {
    size: 'small',
    variant: 'outlined',
    InputLabelProps: { shrink: true },
  },
  styleOverrides: {
    root: {
      '& label': {  fontSize: '1.2rem', fontWeight: 700, color: '#000000' },
      '& label.Mui-focused': { color: '#000000' },
      '& label.MuiFormLabel-filled': { color: '#000000' },
      '& input': { fontSize: '1rem', fontWeight: 500, color: '#111111' },
    },
  },
},
    MuiGrid: {
  styleOverrides: {
    container: {
      width: '100% !important',
      margin: '0 !important',
    },
  },
},
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '1.3rem' ,
          fontWeight: 700,
          color: '#1a237e',
        },
      },
    },
  },
});
// हे function component च्या आत add करा (handleChange च्या खाली):
const handleEnterKey = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    const form = e.currentTarget;
    const inputs = Array.from(
      form.querySelectorAll('input, textarea, select, button')
    );
    const currentIndex = inputs.indexOf(e.target);
    const next = inputs[currentIndex + 1];
    if (next) next.focus();
  }
};

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    studentId: '',
    uidNo: '',
    aadharCard: '',
    dakhalNo: '',
    anuKramank: '',
    registerNo: '',
    firstName: '',
    middleName: '',
    lastName: '',
    motherName: '',
    nationality: '',
    motherTongue: '',
    religion: '',
    caste: '',
    subCaste: '—',
    birthPlace: '',
    taluka: '',
    district: '',
    dobDigit: '',
    dobWords: '',
    prevSchool: '',
    admissionDate: '',
    admissionClass: '',
    progress: '',
    conduct: '',
    currentClassDetails: '',
    leavingDate: '',
    leavingReason: '',
    remark: '',
    generalRegisterNo: '',
    dateDay: '',
    dateMonth: '',
    dateYear: ''
  });

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleSaveAction = () => {
    toast((t) => (
      <Box sx={{ p: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#1a237e' }}>
          Data saved successfully! Do you want to print this certificate now?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => toast.dismiss(t.id)}
            sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 'bold' }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              toast.dismiss(t.id);
              doPrint();
            }}
            sx={{ borderRadius: 1.5, textTransform: 'none', color: '#fff', fontWeight: 'bold' }}
          >
            Yes (Print)
          </Button>
        </Box>
      </Box>
    ), {
      duration: 8000,
      position: 'top-center',
      style: {
        background: '#ffffff',
        color: '#333333',
        boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
        borderRadius: '16px',
        padding: '16px',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        minWidth: '360px'
      }
    });
  };

 return (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Toaster />
    
    {/* Actions Header */}
    <Box sx={{ 
  display: 'flex', 
  flexDirection: 'row',          // ← column नको, row करा
  justifyContent: 'space-between', // ← title left, buttons right
  alignItems: 'center',
  px: { xs: 1.5, sm: 3 }, 
  py: 1.5, 
  borderBottom: '1px solid #e0e0e0',
}} className="no-print-zone">

  <Typography variant="h6" sx={{ 
    fontWeight: 'bold', 
    color: 'primary.main', 
    fontSize: { xs: '0.85rem', sm: '1.25rem' },
    flex: 1                      // ← title जास्त space घेईल
  }}>
    Student Registration Control Center
  </Typography>

  <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>  {/* ← buttons shrink होणार नाहीत */}
    <Button variant="contained" color="secondary" startIcon={<SaveIcon />} onClick={handleSaveAction} size="small" sx={{ color: '#fff', borderRadius: 2 }}>
      डेटा जतन करा
    </Button>
    <Button variant="contained" color="primary" startIcon={<PrintIcon />} onClick={doPrint} size="small" sx={{ borderRadius: 2 }}>
      दाखला प्रिंट
    </Button>
  </Box>

</Box>

    {/* Form */}
    <Box sx={{ width: '100%', overflow: 'auto', p: 2, boxSizing: 'border-box' }} className="no-print-zone" onKeyDown={handleEnterKey}>
      
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h5" color="primary" sx={{ fontWeight: 'bold' }}>छत्रपती शिवाजी विद्यालय, भोर</Typography>
        <Divider sx={{ my: 2, borderBottomWidth: 2, borderColor: 'primary.main' }} />
      </Box>

      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>[१] सिस्टम आयडेंटिफायर्स</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}><TextField label="स्टूडंट आय.डी." fullWidth size="small" value={formData.studentId} onChange={handleChange('studentId')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="यु.आय.डी.नं." fullWidth size="small" value={formData.uidNo} onChange={handleChange('uidNo')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="आधार कार्ड नंबर" fullWidth size="small" value={formData.aadharCard} onChange={handleChange('aadharCard')} /></Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>[२] विद्यार्थ्याची वैयक्तिक माहिती</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}><TextField label="विद्यार्थ्याचे नांव" fullWidth size="small" value={formData.firstName} onChange={handleChange('firstName')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="वडिलांचे नांव" fullWidth size="small" value={formData.middleName} onChange={handleChange('middleName')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="आडनांव" fullWidth size="small" value={formData.lastName} onChange={handleChange('lastName')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="आईचे नांव" fullWidth size="small" value={formData.motherName} onChange={handleChange('motherName')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="राष्ट्रीयत्व" fullWidth size="small" value={formData.nationality} onChange={handleChange('nationality')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="मातृभाषा" fullWidth size="small" value={formData.motherTongue} onChange={handleChange('motherTongue')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="धर्म" fullWidth size="small" value={formData.religion} onChange={handleChange('religion')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="जात" fullWidth size="small" value={formData.caste} onChange={handleChange('caste')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="पोटजात" fullWidth size="small" value={formData.subCaste} onChange={handleChange('subCaste')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="जन्म गांव / शहर" fullWidth size="small" value={formData.birthPlace} onChange={handleChange('birthPlace')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="तालुका" fullWidth size="small" value={formData.taluka} onChange={handleChange('taluka')} /></Grid>
            <Grid item xs={12} sm={3}><TextField label="जिल्हा" fullWidth size="small" value={formData.district} onChange={handleChange('district')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="जन्म दिनांक (अंकी)" fullWidth size="small" value={formData.dobDigit} onChange={handleChange('dobDigit')} /></Grid>
            <Grid item xs={12} sm={8}><TextField label="जन्म दिनांक (अक्षरी)" fullWidth size="small" value={formData.dobWords} onChange={handleChange('dobWords')} /></Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>[३] शैक्षणिक रेकॉर्ड व शाळा सोडल्याचा तपशील</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}><TextField label="यापूर्वीची शाळा व इयत्ता" fullWidth size="small" value={formData.prevSchool} onChange={handleChange('prevSchool')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="प्रवेश इयत्ता" fullWidth size="small" value={formData.admissionClass} onChange={handleChange('admissionClass')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="या शाळेत प्रवेश दिनांक" fullWidth size="small" value={formData.admissionDate} onChange={handleChange('admissionDate')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="अभ्यासातील प्रगती" fullWidth size="small" value={formData.progress} onChange={handleChange('progress')} /></Grid>
            <Grid item xs={12} sm={4}><TextField label="वर्तणूक" fullWidth size="small" value={formData.conduct} onChange={handleChange('conduct')} /></Grid>
            <Grid item xs={12} sm={6}><TextField label="कोणत्या इयत्तेत शिकत होता व केव्हापासून" fullWidth size="small" value={formData.currentClassDetails} onChange={handleChange('currentClassDetails')} /></Grid>
            <Grid item xs={12} sm={6}><TextField label="शाळा सोडल्याचा दिनांक" fullWidth size="small" value={formData.leavingDate} onChange={handleChange('leavingDate')} /></Grid>
            <Grid item xs={12}><TextField label="शाळा सोडल्याचे कारण" fullWidth size="small" value={formData.leavingReason} onChange={handleChange('leavingReason')} /></Grid>
            <Grid item xs={12}><TextField label="शेरा (Remarks)" fullWidth size="small" value={formData.remark} onChange={handleChange('remark')} /></Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 'bold', mb: 2 }}>[४] जनरल रजिस्टर प्रमाणीकरण</Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}><TextField label="शाळेतील जनरल रजिस्टर नं." fullWidth size="small" value={formData.generalRegisterNo} onChange={handleChange('generalRegisterNo')} /></Grid>
            <Grid item xs={4} sm={2}><TextField label="तारीख" fullWidth size="small" value={formData.dateDay} onChange={handleChange('dateDay')} /></Grid>
            <Grid item xs={4} sm={2}><TextField label="माहे (महिना)" fullWidth size="small" value={formData.dateMonth} onChange={handleChange('dateMonth')} /></Grid>
            <Grid item xs={4} sm={2}><TextField label="सन (वर्ष)" fullWidth size="small" value={formData.dateYear} onChange={handleChange('dateYear')} /></Grid>
          </Grid>
        </CardContent>
      </Card>

    </Box>

    {/* Print Certificate */}
    <PrintCertificate formData={formData} />

  </ThemeProvider>
);
};

export default RegistrationForm;